var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.61 5.15c.563 0 2.585.05 3.916 1.958-.115.09-2.124 1.228-2.124 3.763 0 2.93 2.56 3.968 2.636 3.993-.012.064-.41 1.421-1.357 2.803-.844 1.216-1.727 2.432-3.071 2.432s-1.69-.78-3.226-.78c-1.523 0-2.06.806-3.29.806-1.228 0-2.086-1.126-3.059-2.509C1.883 15.991.962 13.47.962 11.076c0-3.84 2.496-5.876 4.953-5.876 1.306 0 2.394.858 3.226.858.768 0 1.984-.909 3.469-.909zm-.692-1.626c-.665.806-1.792 1.408-2.688 1.408a1.44 1.44 0 01-.256-.026 1.757 1.757 0 01-.038-.358c0-1.024.525-2.035 1.075-2.675.717-.832 1.92-1.46 2.906-1.498.025.115.038.256.038.397 0 1.011-.435 2.022-1.037 2.752z",
    fill: "#fff"
  })));
};
export default SvgApple;